import { createReducer, on } from '@ngrx/store';
import { ProdigyHealthGuidelineActions } from './health-guideline.actions';
import { ProdigyHealthGuidelineState } from './health-guideline.interface';
import {
  initialProdigyHealthGuidelineState,
  prodigyHealthGuidelineState
} from './health-guideline.state';

export const prodigyHealthGuidelineReducer = createReducer(
  prodigyHealthGuidelineState,
  on(
    ProdigyHealthGuidelineActions.reset,
    (): ProdigyHealthGuidelineState => initialProdigyHealthGuidelineState()
  ),
  on(
    ProdigyHealthGuidelineActions.updateLoading,
    (state, { loading }): ProdigyHealthGuidelineState => ({
      ...state,
      loading
    })
  ),
  on(
    ProdigyHealthGuidelineActions.setCgadActivity,
    (state, { cgadActivity }): ProdigyHealthGuidelineState => ({
      ...state,
      cgadActivity
    })
  ),
  on(
    ProdigyHealthGuidelineActions.setChildInsight,
    (state, { childInsight }): ProdigyHealthGuidelineState => ({
      ...state,
      childInsight
    })
  ),
  on(
    ProdigyHealthGuidelineActions.setParentingApproach,
    (state, { parentingApproach }): ProdigyHealthGuidelineState => ({
      ...state,
      parentingApproach
    })
  )
);
